/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ author: NonNullable<unknown>, age: NonNullable<unknown> }} Draft_BylineInputs */

const en_us2_draft_byline = /** @type {(inputs: Draft_BylineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.author} · ${i?.age}`)
};

const pt_br2_draft_byline = /** @type {(inputs: Draft_BylineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.author} · ${i?.age}`)
};

const es_419_draft_byline = /** @type {(inputs: Draft_BylineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.author} · ${i?.age}`)
};

const pt_pt2_draft_byline = /** @type {(inputs: Draft_BylineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.author} · ${i?.age}`)
};

const fr_fr2_draft_byline = /** @type {(inputs: Draft_BylineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.author} · ${i?.age}`)
};

const de_de2_draft_byline = /** @type {(inputs: Draft_BylineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.author} · ${i?.age}`)
};

const it_it2_draft_byline = /** @type {(inputs: Draft_BylineInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.author} · ${i?.age}`)
};

/**
* | output |
* | --- |
* | "{author} · {age}" |
*
* @param {Draft_BylineInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const draft_byline = /** @type {((inputs: Draft_BylineInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_BylineInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_draft_byline(inputs)
	if (locale === "es-419") return es_419_draft_byline(inputs)
	if (locale === "pt-PT") return pt_pt2_draft_byline(inputs)
	if (locale === "fr-FR") return fr_fr2_draft_byline(inputs)
	if (locale === "de-DE") return de_de2_draft_byline(inputs)
	if (locale === "it-IT") return it_it2_draft_byline(inputs)
	return en_us2_draft_byline(inputs)
});
export { draft_byline as "draft.byline" }